import React from 'react'
import { Trans } from '@lingui/macro'

export const attemptLimitOptions = [
  {
    value: '0',
    label: <Trans>Unlimited attempts until passed</Trans>
  },
  {
    value: '2',
    label: <Trans>2 attempts</Trans>
  },
  {
    value: '3',
    label: <Trans>3 attempts</Trans>
  },
  {
    value: '4',
    label: <Trans>4 attempts</Trans>
  },
  {
    value: '5',
    label: <Trans>5 attempts</Trans>
  },
  {
    value: '6',
    label: <Trans>6 attempts</Trans>
  },
  {
    value: '7',
    label: <Trans>7 attempts</Trans>
  },
  {
    value: '8',
    label: <Trans>8 attempts</Trans>
  },
  {
    value: '9',
    label: <Trans>9 attempts</Trans>
  },
  {
    value: '10',
    label: <Trans>10 attempts</Trans>
  }
]
